import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockAlert"
const ClockAlertIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10c2.25 0 4.33-.76 6-2v-2.72C16.53 18.94 14.39 20 12 20a8 8 0 1 1 0-16c3.36 0 6.23 2.07 7.41 5h2.13C20.27 4.94 16.5 2 12 2Zm-1 5v6l5.25 3.15.75-1.23-4.5-2.67V7H11Zm9 4v7h2v-7h-2Zm0 9v2h2v-2h-2Z"
          />
        </svg>
      }
    </span>
  )
}
export default ClockAlertIcon
